import PickupPersonForm from 'components/FrictionlessCheckout/DeliverToReleaseThree/ShipToAccessPoint/PickupPersonForm/PickupPersonForm';
import { connect } from 'react-redux';
import { createStructuredSelector, createSelector } from 'reselect';

import { userSelector } from 'selectors/user/userSelector';
import { orderSelector } from 'selectors/order/orderSelector';
import OrderActions from 'actions/OrderActions';
import AddressActions from 'actions/AddressActions';
import CheckoutActions from 'actions/CheckoutActions';
import localeUtils from 'utils/LanguageLocale';
import { getLocationHoursText } from 'utils/AccessPoints';
import decorators from 'utils/decorators';
import checkoutApi from 'services/api/checkout';
import { INTERSTICE_DELAY_MS } from 'constants/Checkout';
import anaConsts from 'analytics/constants';
import processEvent from 'analytics/processEvent';
import ErrorsUtils from 'utils/Errors';
import store from 'store/Store';
import Location from 'utils/Location';
import { refreshCheckout } from 'services/Checkout';
import FrictionlessUtils from 'utils/FrictionlessCheckout';
import { SECTION_NAMES } from 'constants/frictionlessCheckout';
const { createDraftHalAddress } = CheckoutActions;
import ShipToAccessPointEN from 'components/FrictionlessCheckout/DeliverToReleaseThree/ShipToAccessPoint/locales/ShipToAccessPoint_en_US';
import ShipToAccessPointFR from 'components/FrictionlessCheckout/DeliverToReleaseThree/ShipToAccessPoint/locales/ShipToAccessPoint_fr_CA';

const { getTextFromResource, getLocalisedDataFromResource, isCanada } = localeUtils;

const getText = getLocalisedDataFromResource(ShipToAccessPointEN, ShipToAccessPointFR);

const createShippingAddress = (halAddressPayload, currentHalAddress, callback) => {
    decorators
        .withInterstice(
            checkoutApi.createShippingAddress,
            INTERSTICE_DELAY_MS
        )(halAddressPayload)
        .then(() => {
            store.dispatch(OrderActions.sectionSaved(Location.getLocation().pathname, null));
            store.dispatch(OrderActions.updateCurrentHalAddress(currentHalAddress));
            refreshCheckout()()
                .then(() => {
                    return Promise.resolve(FrictionlessUtils.updateCheckoutURLBasedOnOrderCompleteness());
                })
                .then(() => {
                    // This makes sure we only run this block of code after URL gets updated to avoid unnecessary race issues
                    // Dispatch after refresh so orderDetails has isComplete=true when
                    // updateAddressListWithHalAddress triggers renderItemList. If called before
                    // refresh, renderItemList runs with stale isComplete=false and spuriously sets
                    // addressNeedsToBeConfirmed=true, which persists through navigation and causes
                    // "Please confirm your selection." on Place Order. Mirrors ShipToAccessPoint/index.js.
                    store.dispatch(OrderActions.setAddressNeedsConfirmation(false));
                    store.dispatch(OrderActions.clearNamedSectionErrors([SECTION_NAMES.DELIVER_TO]));
                    store.dispatch(OrderActions.updateAddressListWithHalAddress(true));
                    callback(false);
                });

            processEvent.process(anaConsts.ADD_SHIPPINGINFO_EVENT, {
                data: {}
            });
        })
        .catch(errorData => {
            ErrorsUtils.collectAndValidateBackEndErrors(errorData, null);
        });
};

const resetAccessPoint = () => {
    store.dispatch(OrderActions.removeHalAddress());
    store.dispatch(OrderActions.togglePlaceOrderDisabled(true));
};

const localization = createStructuredSelector({
    pickupPerson: getTextFromResource(getText, 'pickupPerson'),
    idRequired: getTextFromResource(getText, isCanada() ? 'idRequiredCA' : 'idRequired'),
    firstName: getTextFromResource(getText, 'firstName'),
    lastName: getTextFromResource(getText, 'lastName'),
    email: getTextFromResource(getText, 'email'),
    emailRequiredText: getTextFromResource(getText, 'emailRequiredText'),
    phoneNumber: getTextFromResource(getText, 'phoneNumber'),
    streetAddress: getTextFromResource(getText, 'streetAddress'),
    addressLine2: getTextFromResource(getText, 'addressLine2'),
    postalCode: getTextFromResource(getText, 'postalCode'),
    invalidPostalCode: getTextFromResource(getText, 'invalidPostalCode'),
    enterPostalCode: getTextFromResource(getText, 'enterPostalCode'),
    city: getTextFromResource(getText, 'city'),
    province: getTextFromResource(getText, 'province'),
    shipToAddress: getTextFromResource(getText, 'shipToAddress'),
    idRequiredEditMode: getTextFromResource(getText, isCanada() ? 'idRequiredEditModeCA' : 'idRequiredEditMode'),
    modelButtonText: getTextFromResource(getText, 'modelButtonText'),
    cancelButtonText: getTextFromResource(getText, 'cancelButtonText')
});

const dataSelector = createStructuredSelector({
    user: userSelector,
    order: orderSelector,
    localization
});

const withShipToAccessPointProps = connect(
    createSelector(dataSelector, data => {
        return {
            ...data,
            createShippingAddress,
            getLocationHoursText,
            resetAccessPoint,
            isCanada: isCanada(),
            createDraftHalAddress
        };
    }),
    {
        getStateList: AddressActions.getStateList
    }
);

const ConnectedShipToAccessPoint = withShipToAccessPointProps(PickupPersonForm);
ConnectedShipToAccessPoint.displayName = 'ConnectedPickupPersonForm';

export default ConnectedShipToAccessPoint;
